import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.83266 3.64H7.14266V2.48H5.83266V3.64ZM5.88266 10H7.09266V4.52H5.88266V10Z",
		fill: "#FA4F38"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 6.5,
		cy: 6.5,
		r: 6,
		stroke: "#FA4F38"
	})]
});
export default SvgInfoLight;
